import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { StorageService } from '../storage/storage.service';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { SnackbarAlertService, SnackBarDuration, SnackBarType } from '../../shared/snackbar-alert/snackbar-alert.service';
import { NavigationPathFunctions } from '../../utils/navigation.path.functions';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ErrorMessageResolverService } from '../cloud/error-handler.service';

interface HttpErrorResponseWithDisplayErrorMessage extends HttpErrorResponse {
  displayErrorMessage: string;
}

export const tokenInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const router = inject(Router);
  const snackbarAlertService = inject(SnackbarAlertService);

  const token = StorageService.getAuthToken?.access_token;

  // Don't set Authorization header if token is from cookie (it's already in HTTP-only cookie)
  const authHeader = (token && token !== 'from_cookie') ? `Bearer ${token}` : `Basic ${environment.basicToken}`;

  req = req.clone({
    setHeaders: {
      Accept: 'application/json',
      Authorization: authHeader
    },
    withCredentials: true
  });

  return next(req).pipe(
    catchError((error: HttpErrorResponseWithDisplayErrorMessage) => {
      error.displayErrorMessage = ErrorMessageResolverService.getErrorMessage(error);

      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          snackbarAlertService.showSnackBar('Unauthorized', SnackBarType.ERROR, SnackBarDuration.LENGTH_SHORT);

          StorageService.clearAuthToken();

          router.navigate([NavigationPathFunctions.navigateToSignIn()]);
        }
      }

      return throwError(() => error);
    })
  );
};
